import { ChevronRight } from '@mui/icons-material'
import { Avatar, Box, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material'
import { PublicationIcon, SaveIcon, SearchIcons } from '../../../core/global/Icons'
import { useHistory } from "react-router-dom";

export const Desktop = () => {

    const history = useHistory();

    let data_item = [
        {
            features: 'Publication',
            description: 'Discover articles, news, and updates shared by different authors.',
            icon: <PublicationIcon type="active" />,
            name: 'publication'
        },
        {
            features: 'Save',
            description: 'Access the items you’ve bookmarked for later reading.',
            icon: <SaveIcon width={22} height={22} type="active"/>,
            name: 'save'
        },
        {
            features: 'Search',
            description: 'Find articles, news, and updates instantly.',
            icon: <SearchIcons size={22} stroke="#453FBA" />,
            name: 'search'
        },
    ]

    const clickHandler = (name) => {
        if (name === 'publication'){
            history.push('/psl/publication?tab=article')
        } else if (name === 'save'){
            history.push('/psl/save')
        }  else if (name === 'search'){
            history.push('/psl/search')
        }
    }

    return (
        <Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center" flexDirection="column" bgcolor="#fff">
            <Box display="flex" alignItems="center" flexDirection="column" my="50px" gap="24px">
                <Box fontSize="20px" color="#453FBA" fontWeight="600">404</Box>
                <Box fontSize="54px" fontWeight="600" >Oops! Page Not Found.</Box>
                <Box fontSize="16px" >It seems the page you're looking for doesn't exist or may have been moved.</Box>
            </Box>
            <Box>
                <List>
                    {data_item.map((v, i) => (
                        <>
                            <ListItem key={i} onClick={() => clickHandler(v.name)} sx={{width: '600px'}}>
                                <ListItemButton>
                                    <ListItemAvatar>
                                        <Avatar sx={{background: '#d6e4f3'}}>{v.icon}</Avatar>
                                    </ListItemAvatar>
                                    <ListItemText 
                                        primary={<Box fontSize="16px" fontWeight="600">{v.features}</Box>}
                                        secondary={<Box fontSize="14px" color="">{v.description}</Box>}
                                    />
                                    <IconButton edge="end" aria-label="delete">
                                        <ChevronRight />
                                    </IconButton>
                                </ListItemButton>
                            </ListItem>
                            {i !== data_item.length - 1 && <Divider variant="middle" />}
                        </>
                    ))}
                </List>
            </Box>
        </Box>
    )
}
